import React, { useState, useEffect } from 'react';

const InstallPrompt = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showPrompt, setShowPrompt] = useState(false);

  useEffect(() => {
    if (localStorage.getItem('hasSeenInstallPrompt')) {
      return;
    }

    // Check if the URL has ?install=true
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('install') === 'true') {
      setShowPrompt(true);
    }

    const handleBeforeInstallPrompt = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      // Also show it if the browser fires it automatically
      setShowPrompt(true);
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    };
  }, []);

  const handleInstallClick = async () => {
    localStorage.setItem('hasSeenInstallPrompt', 'true');
    if (deferredPrompt) {
      deferredPrompt.prompt();
      const { outcome } = await deferredPrompt.userChoice;
      if (outcome === 'accepted') {
        setShowPrompt(false);
      }
      setDeferredPrompt(null);
    } else {
      // Fallback for iOS / Safari which doesn't support beforeinstallprompt
      alert('To install the app on iOS, tap the Share icon and select "Add to Home Screen".');
      setShowPrompt(false);
    }
  };

  const handleClose = () => {
    localStorage.setItem('hasSeenInstallPrompt', 'true');
    setShowPrompt(false);
  };

  if (!showPrompt) return null;

  return (
    <div style={styles.overlay}>
      <div style={styles.modal}>
        <h2 style={styles.title}>Install Our App</h2>
        <p style={styles.text}>
          Install the ceindiazone2 app on your device for quick access and offline capabilities!
        </p>
        <div style={styles.buttonContainer}>
          <button style={styles.installBtn} onClick={handleInstallClick}>Install App</button>
          <button style={styles.closeBtn} onClick={handleClose}>Not Now</button>
        </div>
      </div>
    </div>
  );
};

const styles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.8)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 99999,
  },
  modal: {
    backgroundColor: '#1d2024',
    padding: '30px',
    borderRadius: '16px',
    border: '1px solid #136488',
    maxWidth: '90%',
    width: '400px',
    textAlign: 'center',
    boxShadow: '0 10px 30px rgba(0,0,0,0.5)',
  },
  title: {
    color: '#5DB3E8',
    marginTop: 0,
    fontFamily: 'Montserrat, sans-serif',
  },
  text: {
    color: '#d0d0d0',
    marginBottom: '25px',
    lineHeight: '1.5',
    fontFamily: 'Open Sans, sans-serif',
  },
  buttonContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },
  installBtn: {
    backgroundColor: '#5DB3E8',
    color: '#1A2E49',
    border: 'none',
    padding: '12px',
    borderRadius: '8px',
    fontSize: '16px',
    fontWeight: 'bold',
    cursor: 'pointer',
  },
  closeBtn: {
    backgroundColor: 'transparent',
    color: '#d0d0d0',
    border: '1px solid #d0d0d0',
    padding: '12px',
    borderRadius: '8px',
    fontSize: '16px',
    cursor: 'pointer',
  }
};

export default InstallPrompt;
